































import {
  captionsForSignupContext
} from '@spa/components/pages/auth/signup/with-sms/components/note/default/signup-note-for-context'
import { Component, Prop, Vue } from 'vue-property-decorator'

import TelForm from '@spa/components/organisms/profile/TelForm.vue'

@Component({
  components: {
    TelForm,
  },
})
export default class InputTel extends Vue {
  @Prop({ required: true })
  readonly step: number

  tel: string = ''

  get caption() {
    return captionsForSignupContext.forPlanApplySignup
  }

  handleTelFormUpdated(tel: string) {
    this.tel = tel
  }

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }

    this.$emit('submit-tel', this.tel)
  }

  private async validateForm(): Promise<boolean> {
    if (this.tel.length === 0) {
      return false
    }

    this.$validator.validateAll()

    return this.$validator.validateAll()
  }
}
